module.exports = __webpack_public_path__ + "static/img/cover4.2e24b549.jpg";